import styled from "styled-components";

export const Sekcja = styled.section`
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px clamp(16px, 5vw, 72px) 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    align-items: center;
  }
`;

export const Opis = styled.div`
  max-width: 550px;
  text-align: left;
  display: flex;
  flex-direction: column;

  .eyebrow { margin: 0 0 8px; color: ${({ theme }) => theme.color.green}; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase; }
  h2 { margin: 0 0 20px; }
  p { line-height: 1.6; }
`;

export const Elementy = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: -25px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    align-self: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PodpisJustyna = styled.div`
  grid-area: 1 / 2 / 2 / 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 200px;
`;

export const PodpisPawel = styled.div`
  grid-area: 2 / 2 / 3 / 3;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 200px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    grid-area: 3 / 1 / 4 / 2;
  }
`;

export const Justyna = styled.p`
  max-width: 200px;
  margin-bottom: 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.orange};
`;

export const WyksztalcenieJustyna = styled.p`
  font-size: 14px;
  line-height: 18px;
  width: 140px;
`;

export const Pawel = styled.p`
  text-align: right;
  margin-bottom: 0;
  max-width: 200px;
  border-bottom: 1px solid ${({ theme }) => theme.color.orange};
`;

export const WyksztalceniePawel = styled.p`
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  width: 140px;
  align-self: flex-end;
`;

export const ZdjeciePawel = styled.img`
  grid-area: 1 / 3 / 3 / 4;
  align-self: end;
  max-width: 200px;
  height: auto;
  object-fit: contain;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    max-width: 150px;
    grid-area: 2 / 2 / 4 / 2;
  }
`;

export const ZdjecieJustyna = styled.img`
  grid-area: 1 / 1 / 3 / 2;
  max-width: 200px;
  height: auto;
  object-fit: contain;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    max-width: 150px;
  }
`;

export const Paragraf = styled.p`
  font-size: 24px;
`;

export const Informacja = styled.div`
  min-height: 220px;
  background: linear-gradient(120deg, #ffb51f, ${({ theme }) => theme.color.orange});
  text-align: center;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
  grid-auto-rows: 1fr;
  padding: 38px clamp(16px, 5vw, 72px);

  > div { display:flex; flex-direction:column; justify-content:center; padding: 24px 16px; border: 1px solid rgba(255,255,255,.34); border-radius: 20px; background: rgba(255,255,255,.2); }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    padding: 20px 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) { grid-template-columns: repeat(2,minmax(0,1fr)); gap:8px; min-height:0; padding:20px 16px; >div { padding:16px 10px; border-radius:16px; } h4 { font-size:22px; line-height:1.2; } p { font-size:13px; line-height:1.4; margin:8px 0 0; } }
`;

export const Naglowek = styled.h4`
  font-size: 28px;
  margin-bottom: 0;
  margin-top: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-top: 0px;
  }
`;

export const Podnaglowek = styled.p`
  margin-top: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-top: 0px;
  }
`;

